<div class="alert {{ type }}">
  <cb-icon *ngIf="type ==='success'" name="check-circle"></cb-icon>
  <cb-icon *ngIf="type ==='error'" name="exclamation-circle"></cb-icon>
  <cb-icon *ngIf="type ==='warning'" name="question-circle"></cb-icon>
  <div class="text">
    <ng-content></ng-content>
  </div>
</div>
